export const validateEmptyValue = <T>(value: T): boolean => {
  return (
    value === undefined ||
    value === null ||
    value === '' ||
    (typeof value === 'object' && value !== null && Object.keys(value).length === 0) ||
    (Array.isArray(value) && value.length === 0)
  );
};
